import React from 'react';
const MissionSection = () => {
  return <section className="bg-[#c19a3c] py-16 px-6 md:px-24 lg:px-40" data-id="element-76">
      <p className="text-white text-center text-lg md:text-xl leading-relaxed" data-id="element-77">
        At Maverick Legacy Foundation, we believe every leader carries within
        them a vision capable of transforming communities. Our mission is to
        nurture that vision, provide the tools to grow it, and inspire action
        that creates lasting legacy.
      </p>
    </section>;
};
export default MissionSection;